import Vue from 'vue';
import store from './store';
import { authGuard } from '@/auth';
function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

function loadComponent(name) {
  const component = import(
    /* webpackChunkName: "view-[request]" */ `@/components/${name}.vue`
  );
  return () => component;
}
function featuredComponent(feature) {
  let enabled = Vue.prototype.$ld.flags[feature.flag];
  if (enabled) return feature.feature;
  else return feature.standard;
}
function loadFeatureComponent(feature) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/components/${featuredComponent(
        feature
      )}.vue`
    );
}
const isAdmin = (to, from, next) => {
  if (store) {
    if (store.getters['orders/isAdmin']) {
      next();
      return;
    } else next('/');
  }
};

const hasAddress = (to, from, next) => {
  if (store) {
    if (store.getters['orders/hasAddress']) {
      next();
      return;
    } else next('/');
  }
};

const isBusiness = (to, from, next) => {
  if (store) {
    if (!store.getters['orders/isResidential']) {
      next();
      return;
    } else next('/create-sip');
  }
};

const Attachments = {
  props: ['General', 'Licence', 'Business Card', 'Bill'],
  template: '<div>User {{ id }}</div>',
};

export const routes = [
  {
    path: '/',
    component: loadComponent('Home'),
    beforeEnter: authGuard,
    name: 'home',
  },
  {
    path: '/resources-list/:category',
    name: 'ResourceList',
    component: loadComponent('pages/create-order/resources-list'),
    beforeEnter: authGuard,
  },
  {
    path: '/Customers',
    component: loadComponent('customer-details'),
    name: 'Customers',
    beforeEnter: authGuard,
  },
  {
    path: '/create-company',
    component: loadComponent('create-company'),
    name: 'CreateCompany',
    beforeEnter: authGuard,
  },
  {
    path: '/change-lessee',
    component: loadComponent('change-lessee'),
    name: 'ChangeLessee',
    beforeEnter: authGuard,
  },
  {
    path: '/create-customer',
    component: loadComponent('create-customer'),
    name: 'CreateCustomer',
    beforeEnter: authGuard,
  },
  // {
  //   path: "/create-contacts",
  //   component: loadComponent("create-contacts"),
  //   name: "CreateContacts",
  //   beforeEnter: authGuard,
  // },
  {
    path: '/create-contacts',
    component: loadComponent('create-contacts'),
    name: 'CreateContacts',
    beforeEnter: hasAddress,
  },
  {
    path: '/change-address',
    component: loadComponent('change-address'),
    name: 'ChangeAddress',
    beforeEnter: authGuard,
  },
  {
    path: '/create-finance',
    component: loadComponent('create-finance'),
    name: 'CreateFinance',
    beforeEnter: authGuard,
  },
  {
    path: '/view-finance/:guid',
    component: loadComponent('view-finance'),
    name: 'ViewFinance',
    style: 'glyphicon glyphicon-education',
  },
  {
    path: '/view-relocation/:guid',
    component: loadComponent('externalView/view-relocation'),
    name: 'ViewRelocation',
    style: 'glyphicon glyphicon-education',
  },
  {
    path: '/view-lessee-change/:guid',
    component: loadComponent('externalView/view-lessee-change'),
    name: 'ViewLesseeChange',
    style: 'glyphicon glyphicon-education',
  },
  {
    path: '/direct-debit',
    component: loadFeatureComponent({
      standard: 'DirectDebit',
    }),
    name: 'DirectDebit',
    beforeEnter: hasAddress,
  },
  {
    path: '/quote-details',
    component: loadComponent('quote/quote-details'),
    name: 'QuoteDetails',
    beforeEnter: authGuard,
  },
  {
    path: '/create-pstn',
    component: loadComponent('create-pstn'),
    name: 'CreatePstn',
    beforeEnter: hasAddress,
  },
  {
    path: '/create-ipvoice',
    component: loadComponent('create-ipvoice'),
    name: 'CreateIPVoice',
    beforeEnter: authGuard && isBusiness,
  },
  {
    path: '/create-fax',
    component: loadComponent('create-vfax'),
    name: 'CreateFax',
    beforeEnter: authGuard && false,
  },
  //feature flag
  {
    path: '/create-fax-quote',
    component: loadComponent('create-vfax-1727'),
    name: 'CreateFaxQuote',
    beforeEnter: authGuard && false,
  },
  {
    path: '/create-hardware/:confirmDelivery',
    // component: loadComponent("create-hardware"),
    component: loadFeatureComponent({
      flag: 'quoteTool',
      standard: 'create-hardware',
      feature: 'create-hardware-1727',
    }),
    name: 'CreateHardware',
    beforeEnter: authGuard,
    props: {
      confirmDelivery: false,
    },
  },
  {
    path: '/create-mobile',
    // component: loadComponent("create-mobile"),
    component: loadComponent('create-mobile'),
    name: 'CreateMobile',
    beforeEnter: authGuard && false,
  },
  {
    path: '/create-internet',
    component: loadComponent('create-internet'),
    name: 'CreateInternet',
    beforeEnter: authGuard && false,
  },
  {
    path: '/create-inbound',
    component: loadComponent('create-inbound'),
    name: 'CreateInbound',
    beforeEnter: authGuard && false,
  },
  //feature flag
  {
    path: '/create-inbound-quote',
    component: loadComponent('create-inbound-1722'),
    name: 'CreateInboundQuote',
    beforeEnter: authGuard && false,
  },
  {
    path: '/create-porting',
    component: loadComponent('create-porting'),
    name: 'CreatePorting',
    beforeEnter: authGuard,
  },
  {
    path: '/create-sip',
    component: loadComponent('create-sip'),
    name: 'CreateSip',
    beforeEnter: authGuard,
  },
  {
    path: '/create-teams',
    component: loadComponent('create-teams'),
    name: 'CreateTeams',
    beforeEnter: authGuard,
  },
  {
    path: '/attachments/:fileType',
    component: loadComponent('order-attachments'),
    name: 'OrderAttachments',
    beforeEnter: authGuard,
    props: {
      default: false,
      summary: true,
    },
  },
  {
    path: '/app-status',
    component: loadComponent('app-blank'),
    name: 'appStatus',
  },

  {
    path: '/order-summary',
    component: loadComponent('order-summary'),
    name: 'Summary',
    style: 'glyphicon glyphicon-education',
    beforeEnter: authGuard,
  },
  {
    path: '/approve/:guid',
    component: loadComponent('order-approve'),
    name: 'OrderApprove',
    style: 'glyphicon glyphicon-education',
  },
  {
    path: '/docusign/:guid',
    component: loadComponent('order-docusign'),
    name: 'OrderDocusign',
    style: 'glyphicon glyphicon-education',
  },
  {
    path: '/docusignSuccess/:guid/:signed',
    component: loadComponent('order-docusign'),
    name: 'DocusignSuccess',
    style: 'glyphicon glyphicon-education',
  },
  {
    path: '/callback',
    name: 'callback',
    component: loadComponent('Callback'),
  },
  {
    path: '/create-cmc',
    name: 'createCMC',
    component: loadComponent('create-cmc'),
    beforeEnter: authGuard,
  },
  {
    path: '/qantas',
    name: 'Qantas',
    component: loadView('Qantas'),
    beforeEnter: authGuard,
  },
  // {
  //   path: '/dealer-register',
  //   name: 'DealerRegister',
  //   component: loadComponent('dealerportal/dealer-register'),
  //   beforeEnter: authGuard,
  // },
  {
    path: '/api',
    name: 'API',
    beforeEnter() {
      //buttons here

      //. beforeEnter: ifNotAuthenticated,
      location.href = 'https://sogapi.vonex.com.au';
    },
  },
  {
    path: '/login',
    name: 'login',
    component: loadView('Login'),
  },
  {
    path: '/order-types',
    name: 'orderType',
    component: loadComponent('pages/create-order/order-type'),
  },
  {
    path: '/generate-quote',
    name: 'GenerateQuote',
    component: loadComponent('quote/generate-quote'),
  },
  {
    path: '/other-charges',
    name: 'InstallationCharges',
    component: loadComponent('installation-charges'),
  },
  {
    path: '/external-charges',
    name: 'ExternalCharges',
    component: loadComponent('external-charges'),
  },
  {
    path: '/unauthorized',
    name: 'Loading',
    component: loadView('Loading'),
    // beforeEnter: authGuard,
  },
  {
    path: '*',
    redirect: (to) => {
      return { path: '/' };
    },
  },
];
